import { z } from 'zod';
// A signer can be re-emailed at most this often, so a busy sender can't flood their inbox.
export const SIGNER_RESEND_COOLDOWN_MINUTES = 10;
const CHOOSE_WHO_SIGNS = 'Choose who signs';
export const signatureRequestCreateSchema = z.object({
    // One per signer, in the document type's order. A signer nobody has picked yet is null.
    signerUserIds: z
        .array(z.number(CHOOSE_WHO_SIGNS).int().positive().nullable().pipe(z.number(CHOOSE_WHO_SIGNS)))
        .min(1),
    note: z.string().trim().max(1000).optional(),
});
